<template>
    <div class="alert-message-area">
      <div class="pd10"
           style="line-height: 18px;"
           v-html="props.message"/>
      <button class="ssmall bt-purple mgt10"
              ref="elBtn"
              @click="close">확인</button>
    </div>
</template>

<script setup>
import {defineProps, onMounted, ref, defineEmits, nextTick} from 'vue';
import {hide} from "@/utils/alert";

const elBtn = ref(null);
const props = defineProps({
  message: {
    type: String,
    required: true
  },
});

const emits = defineEmits(['close']);
const close = () => {
  hide();
  emits('close');
}

onMounted(async () => {
  await nextTick(() => {
    // 확인 버튼에 focus
    elBtn.value.focus();
  })
})

</script>

<style scoped>
.alert-message-area {
  text-align: center;
  min-width: 200px;
  overflow: hidden;
  word-break: break-all;
  font-size: 14px;
}
</style>
